import * as React from 'react';
import { WithChildrenCommonProps } from '@types';
import { IconNames, Icon } from '@components/icon';
import { Typography } from '@components/typography';
import {
  getOptionStylesAsClassName,
  getOptionIconStylesAsClassName,
} from './option-styles';
import { twMerge } from 'tailwind-merge';

export interface IOptionProps {
  /** Value this option represents */
  value: string | Record<string, unknown>;
  /** Handles click event from parent passing the value */
  onClick?: (
    event: React.MouseEvent<HTMLButtonElement>,
    value: string | Record<string, unknown>
  ) => void;
  /** Changes the visual aspect of the Option */
  selected?: boolean;
  /** Changes the visual aspect of the Option */
  focused?: boolean;
  /** Shows the checkmark icon on the right side when selected */
  showTick?: boolean;
  /** Handles mouse enter event */
  onMouseEnter?: (value: string | Record<string, unknown>) => void;
}

export const Option = ({
  value,
  onClick,
  onMouseEnter,
  selected = false,
  focused = false,
  showTick = true,
  children,
  className: classNameProp,
  ...rest
}: WithChildrenCommonProps<IOptionProps>): JSX.Element => {
  const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick && onClick(event, value);
  };

  const tailwindClassName = twMerge(
    getOptionStylesAsClassName(selected, focused),
    classNameProp
  );

  return (
    <Typography
      component="button"
      type="button"
      className={tailwindClassName}
      variant="body2"
      bold={selected}
      role="menuitem"
      onClick={handleOnClick}
      onMouseEnter={() => onMouseEnter?.(value)}
      {...rest}
    >
      {/* TODO: style svg children: display: block */}
      {children}
      {selected && showTick && (
        <Icon
          className={getOptionIconStylesAsClassName}
          name={IconNames.CHECK}
        />
      )}
    </Typography>
  );
};
